export default __webpack_public_path__ + "static/media/instagram-circle-300x300.1a1b5aed.png";